export enum LocalStorageKeyEnum {
  KeepLoggedIn = 'keepLoggedIn',
  WeatherUnit = 'weather_unit',
  ShowProjectsList = 'showProjectsList',
  ProjectView = 'projectView',
  ProgressOverviewOpen = 'ProgressOverviewOpen',
  WeatherWidgetOpen = 'WeatherWidgetOpen',
  SlicerPreset = 'slicerPreset',
  SingleSlicerPreset = 'singleSlicerPreset',
  IsSidebarShrinked = 'isSidebarShrinked',
  PortfolioDashboardSortOrder = 'portfolio-dashboard-sort-order',
  ReferenceLayers = 'referenceLayers',
}
